import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { ButtonBack, ButtonNext, Slide, Slider } from 'pure-react-carousel';
import React from 'react';
import styled from 'styled-components';
import THEME, { COLOR } from '../../styles/colors';
import Icon from '../Icon/Icon';

interface IStyledCarouselProps {
  $bgColor: string;
  $yPadding: number;
  $maxHeight: number;
}

const StyledCarousel = styled.div<IStyledCarouselProps>`
  width: 100%;
  background-color: ${({ $bgColor }) => $bgColor};
  position: relative;
  text-align: center;
  padding: ${({ $yPadding }) => $yPadding}px 0;
  max-height: ${({ $maxHeight, $yPadding }) => $maxHeight + $yPadding * 2}px;

  & .carousel__back-button,
  & .carousel__next-button {
    cursor: pointer;
    position: absolute;
    top: 0;
    z-index: 100;
    width: 54px;
    height: 100%;
    background-color: ${THEME.shadow.light};

    opacity: 0;
    transition: opacity 0.1s;
    &:hover {
      background-color: ${THEME.shadow.dark};
    }
  }

  &:hover {
    & .carousel__back-button,
    & .carousel__next-button {
      opacity: 1;
    }
  }

  & .carousel__back-button {
    left: 0;
  }

  & .carousel__next-button {
    right: 0;
  }

  & .carousel__slide {
    text-align: center;
  }

  & .carousel__inner-slide {
    padding: 0 8px;
  }
`;

interface ICarouselProps {
  slides: any[];
  naturalSlideHeight: number;
  yPadding?: number;
  bgColor?: string;
}

const Carousel: React.FC<ICarouselProps> = ({
  slides,
  naturalSlideHeight,
  yPadding = 0,
  bgColor = COLOR.white
}) => (
  <StyledCarousel
    $maxHeight={naturalSlideHeight}
    $yPadding={yPadding}
    $bgColor={bgColor}
  >
    <ButtonBack>
      <Icon icon={faChevronUp} size={24} rotation={270} color={COLOR.white} />
    </ButtonBack>
    <Slider>
      {slides.map((child, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Slide index={i} key={i}>
          {child}
        </Slide>
      ))}
    </Slider>
    <ButtonNext>
      <Icon icon={faChevronUp} size={24} rotation={90} color={COLOR.white} />
    </ButtonNext>
  </StyledCarousel>
);

export default Carousel;
